<template>
  <div class="new-help-detail">
    <mt-header fixed :title="currentTitleText" class="title1">
      <mt-button slot="left" icon="back" @click="$router.go(-1)">返回</mt-button>
    </mt-header>
    <div>
      <div class="main-content">
        <div>
          <div class="content-item" v-for="(item, index) in currentContentText" :key="index">
            <div class="title">
              <div>
                <svg-icon :icon-class="titleSvgPath" class-name="cur-icon symbol"></svg-icon>
                <span>{{ item.title }}</span>
              </div>
            </div>
            <div class="content">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global
    PUBLIC_PRODUCT,
    PUBLIC_HELP_PLUS_TITLE,
    PUBLIC_HELP_PLUS_CONTENT
*/

import SvgIcon from '@/components/SvgIcon';

export default {
  name: 'NewHelpDetail',
  comments: { SvgIcon },
  data() {
    return {
      titleText: '',
      titleSvgPath: 'help_symbol',
      product: PUBLIC_PRODUCT.toLowerCase().trim(),
      helpPlusTitle: PUBLIC_HELP_PLUS_TITLE,
      helpPlusContent: PUBLIC_HELP_PLUS_CONTENT,
    };
  },
  computed: {
    currentTitleText() {
      return this.helpPlusTitle.filter(item => item.id === this.$route.query.id)[0].title;
    },
    currentContentText() {
      return this.helpPlusContent.filter(item => item.pid === this.$route.query.id && item.product.indexOf(this.product) > -1);
    },
  },
};
</script>
